export const removeB64MimeInfo = function(b64String) {
    let lastCommaIndex = b64String.lastIndexOf(',');
    let hasMimeInfo = (lastCommaIndex !== -1);
    if(!hasMimeInfo) {
        // Devolver tal cual, nada que hacer.
        return b64String;
    }
    let dataStartIndex = lastCommaIndex + 1;
    let mimelessB64Pdf = b64String.substr(dataStartIndex, b64String.length - dataStartIndex);
    return mimelessB64Pdf;
};
